var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "basicqulityRef" } },
    [
      _c("div", { staticClass: "top_line" }, [
        _c("span", { staticClass: "mainName" }, [
          _vm._v(
            _vm._s(
              _vm.basicQulityForm ? _vm.basicQulityForm.baseInfo.mainName : "--"
            )
          ),
        ]),
      ]),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingFlag,
              expression: "loadingFlag",
            },
          ],
          ref: "basicQulityRef",
          staticClass: "basicQulityClass",
          attrs: {
            model: _vm.basicQulityForm,
            rules: _vm.rules,
            "label-width": "180px",
          },
        },
        [
          _c("el-card", { staticClass: "box-card" }, [
            _c(
              "div",
              {
                staticClass: "clearfix",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_c("span", [_vm._v("企业基本素质")])]
            ),
            _c(
              "div",
              { staticClass: "card-content" },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    ref: "mainCode",
                                    attrs: {
                                      label: "企业名称：",
                                      prop: "mainCode",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.basicQulityForm
                                            ? _vm.basicQulityForm.baseInfo
                                                .mainName
                                            : "--"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    ref: "mainCode",
                                    attrs: {
                                      label: "统一社会信用代码：",
                                      prop: "mainCode",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.basicQulityForm
                                            ? _vm.basicQulityForm.baseInfo
                                                .mainCode
                                            : "--"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    ref: "mainCode",
                                    attrs: {
                                      label: "成立日期：",
                                      prop: "mainCode",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.basicQulityForm
                                            ? _vm.basicQulityForm.baseInfo
                                                .incorporationTime
                                            : "--"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    ref: "mainCode",
                                    attrs: {
                                      label: "注册资本：",
                                      prop: "mainCode",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.basicQulityForm
                                            ? _vm.basicQulityForm.baseInfo
                                                .registerCapital
                                            : "--"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    ref: "mainCode",
                                    attrs: {
                                      label: "企业类型：",
                                      prop: "mainCode",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.basicQulityForm
                                            ? _vm.basicQulityForm.baseInfo
                                                .companyTypeName
                                            : "--"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    ref: "mainCode",
                                    attrs: {
                                      label: "国民经济行业分类：",
                                      prop: "mainCode",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.basicQulityForm
                                            ? _vm.basicQulityForm.baseInfo
                                                .industryCodeName
                                            : "--"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    ref: "mainCode",
                                    attrs: {
                                      label: "法定代表人：",
                                      prop: "mainCode",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.basicQulityForm
                                            ? _vm.basicQulityForm.baseInfo
                                                .entContactVo.orgLegal
                                            : "--"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      _vm._l(
                        _vm.basicQulityForm
                          ? _vm.basicQulityForm.baseInfo.attachments
                          : [],
                        function (item, index) {
                          return item.fileType == 2
                            ? _c(
                                "el-form-item",
                                {
                                  key: index,
                                  attrs: {
                                    label: item.remark
                                      ? item.remark + "："
                                      : "附件：",
                                  },
                                },
                                [
                                  _c("imgUploadView", {
                                    attrs: {
                                      backgroundType: 1,
                                      fileName: item.name,
                                      imgUrl: item.filePath,
                                    },
                                    on: {
                                      "update:fileName": function ($event) {
                                        return _vm.$set(item, "name", $event)
                                      },
                                      "update:file-name": function ($event) {
                                        return _vm.$set(item, "name", $event)
                                      },
                                      "update:imgUrl": function ($event) {
                                        return _vm.$set(
                                          item,
                                          "filePath",
                                          $event
                                        )
                                      },
                                      "update:img-url": function ($event) {
                                        return _vm.$set(
                                          item,
                                          "filePath",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e()
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      [
                        _c(
                          "el-form-item",
                          {
                            ref: "mainCode",
                            attrs: {
                              label: "注册地址：",
                              prop: "mainCode",
                              size: "small",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.basicQulityForm
                                    ? _vm.basicQulityForm.baseInfo.addressDetail
                                    : "--"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-form-item",
                              {
                                ref: "mainCode",
                                attrs: {
                                  label: "经营范围：",
                                  prop: "mainCode",
                                  size: "small",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.basicQulityForm
                                        ? _vm.basicQulityForm.baseInfo
                                            .businessScope
                                        : "--"
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      _vm._l(
                        _vm.basicQulityForm
                          ? _vm.basicQulityForm.baseInfo.attachments
                          : [],
                        function (item, index) {
                          return item.fileType == 3
                            ? _c(
                                "el-form-item",
                                {
                                  key: index,
                                  attrs: {
                                    label: item.remark
                                      ? item.remark + "："
                                      : "附件：",
                                  },
                                },
                                [
                                  _c("imgUploadView", {
                                    attrs: {
                                      backgroundType: 3,
                                      fileName: item.name,
                                      imgUrl: item.filePath,
                                    },
                                    on: {
                                      "update:fileName": function ($event) {
                                        return _vm.$set(item, "name", $event)
                                      },
                                      "update:file-name": function ($event) {
                                        return _vm.$set(item, "name", $event)
                                      },
                                      "update:imgUrl": function ($event) {
                                        return _vm.$set(
                                          item,
                                          "filePath",
                                          $event
                                        )
                                      },
                                      "update:img-url": function ($event) {
                                        return _vm.$set(
                                          item,
                                          "filePath",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e()
                        }
                      ),
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      _vm._l(
                        _vm.basicQulityForm
                          ? _vm.basicQulityForm.baseInfo.attachments
                          : [],
                        function (item, index) {
                          return item.fileType == 4
                            ? _c(
                                "el-form-item",
                                {
                                  key: index,
                                  attrs: {
                                    label: item.remark
                                      ? item.remark + "："
                                      : "附件：",
                                  },
                                },
                                [
                                  _c("imgUploadView", {
                                    attrs: {
                                      backgroundType: 2,
                                      fileName: item.name,
                                      imgUrl: item.filePath,
                                    },
                                    on: {
                                      "update:fileName": function ($event) {
                                        return _vm.$set(item, "name", $event)
                                      },
                                      "update:file-name": function ($event) {
                                        return _vm.$set(item, "name", $event)
                                      },
                                      "update:imgUrl": function ($event) {
                                        return _vm.$set(
                                          item,
                                          "filePath",
                                          $event
                                        )
                                      },
                                      "update:img-url": function ($event) {
                                        return _vm.$set(
                                          item,
                                          "filePath",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e()
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            ref: "mainCode",
                            attrs: {
                              label: "法定代表人手机号",
                              prop: "mainCode",
                              size: "small",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.basicQulityForm
                                    ? _vm.basicQulityForm.baseInfo.entContactVo
                                        .orgLegalTel
                                    : "--"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            ref: "mainCode",
                            attrs: {
                              label: "法定代表人证件信息：",
                              prop: "mainCode",
                              size: "small",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.basicQulityForm
                                    ? _vm.basicQulityForm.baseInfo.entContactVo
                                        .orgCertType
                                    : "--"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            ref: "mainCode",
                            attrs: {
                              label: "法定代表人证件号码：",
                              prop: "mainCode",
                              size: "small",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.basicQulityForm
                                    ? _vm.basicQulityForm.baseInfo.entContactVo
                                        .legalIdCard
                                    : "--"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            ref: "mainCode",
                            attrs: {
                              label: "负责人",
                              prop: "mainCode",
                              size: "small",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.basicQulityForm
                                    ? _vm.basicQulityForm.baseInfo.entContactVo
                                        .responsible
                                    : "--"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            ref: "mainCode",
                            attrs: {
                              label: "负责人手机号：",
                              prop: "mainCode",
                              size: "small",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.basicQulityForm
                                    ? _vm.basicQulityForm.baseInfo.entContactVo
                                        .linkPhone
                                    : "--"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }